import React, { useEffect, useRef, useState } from 'react'
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import logoImage from '../../Assest/logo.png';
// import './Login.css'
import { Toast } from 'primereact/toast';
import { Api } from '../../services/api';
import { Dropdown } from 'primereact/dropdown';
import { Header } from '../../services/api';
import axios from 'axios';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";

const Login = ({ handleLogin }) => {

  const toast = useRef(null);
  const [orgType, setOrgType] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add submitting state

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    organization: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted');
    setIsSubmitting(true); // Disable button

    const url = `${Api.API_BASE_URL}dologin`;

    try {
      console.log(formData.organization);
      formData.organization = selectedItem;
      const response = await fetch(url, {
        method: "POST",
        headers: Api.headers,
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.error) {
        console.log('Error:', data.error);
        toast.current.show({ severity: 'error', detail: data.error });
      } else {
        const { _id, email, first_name, last_name, role_id, name, permission_role, image, roles, rolesList, organizationId } = data.data;
        const token = data.token;
        console.log('user--details', data)
        localStorage.setItem('authToken', token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
        toast.current.show({ severity: 'success', detail: data.message });
        console.log("data result", data.message)
        localStorage.setItem('isLogin', true);
        localStorage.setItem('isLoggedIn', true);
        localStorage.setItem('user_id', _id);
        localStorage.setItem('email', email);
        localStorage.setItem('name', `${first_name} ${last_name}`);
        localStorage.setItem('role_id', role_id._id);
        localStorage.setItem('role_name', name);
        localStorage.setItem('permission_role', role_id.permission_role);
        localStorage.setItem('image', image);
        localStorage.setItem('roles', roles);
        localStorage.setItem('rolesList', rolesList);
        localStorage.setItem('organizationId', organizationId._id)
        localStorage.setItem('organizationName', organizationId.title)
        localStorage.setItem('organizationLogo', organizationId.image)
        localStorage.setItem('isAdmin', role_id.isAdmin)

        if (data.data.role_id !== 1 && data.data.role_id !== 2) {
          setTimeout(() => {
            navigate('/');
            window.location.reload();
          }, 500);
        } else {
          setTimeout(() => {
            navigate('/');
            window.location.reload();
          }, 500);
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.current.show({ severity: 'error', detail: 'An error occurred during the login process.' });
    }finally {
      setIsSubmitting(false); // Re-enable the button after submission
    }
  };

  useEffect(() => {
    // console.log('Fetching org...xx');
    getOrgType();
  }, []);

  const getOrgType = (org) => {


    axios.get(Api.API_BASE_URL + 'get-active-organization')
      .then((response) => {
        const data = response.data.result;
        setOrgType(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching org:', error);
        setIsLoading(false);
      });
  };



  // Call the async function



  const [selectedItem, setSelectedItem] = useState(null);
  // const items = Array.from({ length: 20 }).map((_, i) => ({ label: `Organization #${i+1}`, value: i }));

  return (
    <>
      <Toast ref={toast} />
      <div className="login-container">

        <div className="main">
          <div className='mat-card'>
            <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
              {/* <img src={logoImage} alt="logo" className='img-class' /> */}
              <strong className='text-4xl'>Builder Playbook</strong>
            </div>
            <form onSubmit={handleSubmit} >

              <div className='login-section'>
                <label className='login-lable'>Username</label>
                <input className='input-log' type="email" placeholder="Email" name="username" value={formData.username} onChange={handleInputChange} required />
              </div>

              <div className='login-section'>
                <label className='login-lable'>Password</label>
                <div className="password-container" style={{ position: 'relative' }}>
                  {/* <input className='input-log' type="password" placeholder="Password" name="password" value={formData.password} onChange={handleInputChange} required /> */}
                  <input
                    className='input-log'
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                  />
                  <span
                    className="toggle-password"
                    onClick={togglePasswordVisibility}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '47%',
                      padding: "14px 12px",
                      transform: 'translateY(-50%)',
                      cursor: 'pointer'
                    }}
                  >
                    {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                  </span>
                </div>
              </div>



              <button className='button-login' type="submit"disabled={isSubmitting}  >
              {isSubmitting ? "Logging in..." : "Login"}
              </button>
            </form>
            <div style={{ marginTop: '2rem', textAlign: 'right' }}>
              <Link to="/forget-password" className='login-lable'> Forgot Password</Link>
            </div>
          </div>
        </div>
      </div></>
  );
};

export default Login;